// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kNKm","label":"styles_label__1_V28"};